import { render, staticRenderFns } from "./Edit2.vue?vue&type=template&id=cc23ef12&scoped=true"
import script from "./Edit2.vue?vue&type=script&lang=js"
export * from "./Edit2.vue?vue&type=script&lang=js"
import style0 from "./Edit2.vue?vue&type=style&index=0&id=cc23ef12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc23ef12",
  null
  
)

export default component.exports